export default "/images/vendor/@coreui/icons/svg/flag/cif-pg.svg?0cb60370b1c41c3da44cbaee8eaa1d1a";